import './index.scss'

import React from 'react'
import { Icon, message } from 'antd'
import { Link }   from 'react-router-dom'
import classnames from 'classnames'

import { bindActionCreators } from 'redux'
import { connect }            from 'react-redux'
import { withRouter }         from 'react-router-dom'

import AccountDetails   from '../../../containers/profile-details/account-details'
import PlanUsage        from '../../../containers/profile-details/plan-usage'

import AmazonS3Logo           from '../../../assets/img/gray-aws-s3-logo.png'
import GoogleCloudLogo        from '../../../assets/img/gray-google-cloud-logo.png'
import CloudFlyerCloudLogo       from '../../../assets/img/gray-CloudFlyer-cloud-logo.png'
import UseCloudFlyerTransferLogo from '../../../assets/img/use-cloudflyer-transfer.png'
import {refresh_profile}      from "../../../actions/auth"
import InputModal             from "../../../components/Shared/InputModal"
import CloudFlyerAPI             from "../../../api/CloudFlyerAPI";

const providers = [
  {
    name: 'aws',
    img: AmazonS3Logo,
  },
  {
    img: GoogleCloudLogo,
    name: 'google'
  },
  {
    img: CloudFlyerCloudLogo,
    name: 'CloudFlyer_cloud'
  }
]

class ProfileDetails extends React.Component {

  componentDidMount(){
    this.props.refresh_profile(true)
  }

  open_request_limit_extension = _ => this.inputModal.open()

  request_limit_extension = msg =>{
    let $this = this
    CloudFlyerAPI.quota
      .request_extension(msg)
      .then(_=>{
        $this.inputModal.close()
        message.success('Request send successfully')
      })
      .catch(err => message.error(err.message))
  }

  render() {
    return (
      <div className='profile-details'>
        <div className='account-details-container'>
          <AccountDetails/>
        </div>
        <div className='account-summary-container'>
          <div className='plan-usage-container'>
            <PlanUsage open_request_limit_extension={this.open_request_limit_extension}/>
          </div>
          <div className='footer-container'>
            <div className='left'>
              <YourCloudServices/>
              {/* <NotificationsSwitcher /> */}
            </div>
            <div className='use-CloudFlyer-transfer round-corner'>
              <UseCloudFlyerTransfer/>
            </div>
          </div>
        </div>
        <InputModal
          title       = {'Please write your message to be sent to the administrator to extend your quota.'}
          placeholder = {'message'}
          on_close    = {this.request_limit_extension}
          ref={node=> this.inputModal=node}/>
      </div>
    )
  }
}

const YourCloudServices = () => (
  <div className='cloud-services round-corner'>
    <div>
      <p>Your Cloud Services</p>
      <Link to='/addProvider'>
        <Icon type='plus-circle-o' />
      </Link>
    </div>
    <div>
      {providers.map((provider, index) => (
        <div key={index} className={classnames({ 'selected': false })} >
          <img src={provider.img} alt='' />
        </div>
      ))}
    </div>
  </div>
)

/*const NotificationsSwitcher = () => (
  <div className='notifications-switcher'>
    <div>
      <p>Notifications</p>
      <Switch checkedChildren="On" unCheckedChildren="Off" />
    </div>
    <Link to='#'>
      Advanced
  </Link>
  </div>
)*/

const UseCloudFlyerTransfer = () => (
  <div>
    <img src={UseCloudFlyerTransferLogo} alt="" />
    <p>Transfer your files faster than anyone, safe and cheap!</p>
    <Link to='/S3Direct'>Use Acemly Transfer</Link>
  </div>
)

export default withRouter(connect(({auth}) => ({}), (dispatch) => bindActionCreators({refresh_profile}, dispatch))(ProfileDetails))

